import ReactGA from "react-ga4";

const TRACKING_ID = "G-RWYS34VRNL"; // G-XXXXXXXXXX

export const initGA = () => {
  if (TRACKING_ID) {
    ReactGA.initialize(TRACKING_ID);
  } else {
    console.log("GA4 ID missing: Analytics disabled.");
  }
};

export const logEvent = (category, action, label) => {
  if (TRACKING_ID) {
    ReactGA.event({ category, action, label });
  }
};

// Payload Mappers
const mapPurchasePayload = (data = {}) => ({
  transaction_id: String(data.transactionId || data.transaction_id || ""),
  value: Number(data.value != null ? data.value : (data.total || 0)),
  price: Number(data.price != null ? data.price : (data.subtotal != null ? data.subtotal : (data.value || data.total || 0))),
  currency: data.currency || "EUR",
  coupon: data.coupon || "",
  payment_type: data.payment_type || "card",
  purchase_type: data.purchase_type || "esim_purchase",
  items: data.items || [],
});

const mapEsimOrderPayload = (data = {}) => ({
  transaction_id: String(data.transactionId || data.transaction_id || ""),
  value: Number(data.value != null ? data.value : (data.total || 0)),
  price: Number(data.price != null ? data.price : (data.subtotal != null ? data.subtotal : (data.value || data.total || 0))),
  currency: data.currency || "EUR",
  coupon: data.coupon || "",
  payment_type: data.payment_type || "wallet",
  purchase_type: data.purchase_type || "esim_order",
  items: data.items || [],
});

const mapBusinessPayload = (data = {}) => ({
  transaction_id: String(data.transactionId || data.transaction_id || ""),
  value: Number(data.value || 0),
  currency: data.currency || "EUR",
  coupon: data.coupon || "",
  payment_type: data.payment_type || "wallet",
  purchase_type: data.purchase_type || "",
  item_id: data.item_id ? String(data.item_id) : "",
  item_name: data.item_name || "",
  item_category: data.item_category || "",
  price: Number(data.price || data.value || 0),
  quantity: Number(data.quantity || 1),
});

export const trackAnalyticsEvent = {
  // sign_up — triggered when a user registers using a selected method such as email, Apple, Google, or Facebook.
  signUp: (method) => {
    const formattedMethod = method ? String(method).toLowerCase() : "email";
    ReactGA.event("sign_up", {
      method: formattedMethod,
    });
  },

// login — triggered when a user signs in using a selected method such as email, Apple, Google, or Facebook.
  login: (method) => {
    const formattedMethod = method ? String(method).toLowerCase() : "email";
    ReactGA.event("login", {
      method: formattedMethod,
    });
  },

  // purchase — triggered when a user buys a new eSIM with an external payment method such as card, Apple Pay, or Google Pay. In GA4, this increases ecommerce revenue and purchases.
  purchase: (data) => {
    console.log(data);
    alert("Purchase");
    ReactGA.event("purchase", mapPurchasePayload(data));
  },

  // wallet_topup — triggered when a user adds funds to their wallet. In GA4, this is tracked as a custom event and does not increase ecommerce revenue.
  walletTopUp: (data) => {
    ReactGA.event("wallet_topup", mapBusinessPayload(data));
  },

  // esim_order — triggered when a user buys a new eSIM using wallet balance. In GA4, this is tracked as a custom event and does not increase ecommerce revenue.
  esimOrder: (data) => {
    ReactGA.event("esim_order", mapEsimOrderPayload(data));
  },

  // esim_topup — triggered when a user tops up an existing eSIM using wallet balance. In GA4, this is tracked as a custom event and does not increase ecommerce revenue.
  esimTopUp: (data) => {
    ReactGA.event("esim_topup", mapBusinessPayload(data));
  },

  // screen_view — triggered when a user opens a screen in the app.
  screenView: (screenName) => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: screenName,
    });
  },
};

